import LS from '@utils/local-storage';

export function getSavedState(key) {
  return LS.get(key);
}

export function saveState(key, state, expiry) {
  if (state) {
    LS.set(key, state, expiry);
  } else {
    LS.remove(key);
  }
}
